/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { useEffect, useState, useRef } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../component/button";
import classes from "./order.module.css";
import DialogContent from "@mui/material/DialogContent";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import GenericBPMNForm from "../../../component/genericBPMNForm/genericBPMNForm";
import { Grid, Box } from "@mui/material";
import bpmnFormValidator from "../../../helper/bpmnFormValidator";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Draggable from "react-draggable";
import { Paper, Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { makeStyles } from '@mui/styles';
import fileFormatSizeValidator from "../../../helper/fileFormatSizeValidator";

// Get order props from parent (View Order page)
const OrderActionDialog = (props) => {
  const t = props.t;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");
  // const useStyles = makeStyles({
  //     resizablePaper: {
  //         resize: 'both',
  //         overflow: 'auto',
  //         minWidth: 640,
  //         minHeight: 200,
  //         maxWidth: '90vw',
  //         maxHeight: '90vh',
  //         width: '60vw',
  //     }
  // });
  // const classess = useStyles();
  const fileInputRef = useRef();
  useEffect(() => {
    setFormData(props.data);
  }, []);
  const changeFormField = async (e) => {
    try {
      setError("");
      e.persist();

      let formFields = { ...formData };
      let index = formFields.fields.findIndex(
        (input) => input.id === e.target.name,
      );

      if (index === -1) return;

      let field = formFields.fields[index];

      if (field.type === "upload") {
        const files = e.target.files;
        if (!files.length) return;

        field.value = files[0];
        field.fileName = files[0].name;
        field.fileLength = files.length;

        const validationResult = await fileFormatSizeValidator(files);
        if (validationResult !== "valid") {
          setLoading(false);
          setError(validationResult);
          return;
        }

        // formFields.uploadedFilesData = [];

        // Process each file sequentially
        for (const file of files) {
          // setLoading(true);
          let format = file.name.split(".").pop().toLowerCase();
          let fileType = file.type;
          let fileName = file.name;
          let fileSize = file.size;
          if (formFields.uploadedFilesData) {
            formFields.uploadedFilesData.push({
              uploadedFileName: fileName,
              uploadedFileMimeType: fileType,
              uploadedFileTaskId: formData.taskId,
              originalFile: file,
              isPublic: false,
            });
          } else {
            formFields.uploadedFilesData = [
              {
                uploadedFileName: fileName,
                uploadedFileMimeType: fileType,
                uploadedFileTaskId: formData.taskId,
                originalFile: file,
                isPublic: false,
              },
            ];
          }

          // let formDataPayload = new FormData();
          // formDataPayload.append('file', file);

          // // Simulating API delay and async file upload handling
          // try {
          //     const fileRes = await BusApiCall(
          //         'POST',
          //         `${constants.busV44UrlPublic}/flowable/bpmn/processInstance/${props.bpmnProcessInstanceId}/taskForms/${formData.taskId}/attachments`,
          //         formDataPayload
          //     );
          //     formFields.uploadedFilesData[formFields.uploadedFilesData.length - 1].fileData =
          //         fileRes.data.contentStoreId.split('.')[2]; setLoading(false);
          // } catch (err) {
          //     setLoading(false);
          //     let errorMessage =
          //         err.response?.data?.message || t('DEFAULT_ERROR_MESSAGE');
          //     setError(errorMessage);
          // }
        }
      } else if (field.type === "boolean") {
        field.value = !field.value;
      } else if (field.type === "integer" || field.type === "decimal") {
        const decimalNumberRegexp = /^-?\d+(\.\d{1,2})?$/;
        if (!e.target.value || decimalNumberRegexp.test(e.target.value)) {
          field.value = e.target.value;
        }
      } else {
        field.value = e.target.value;
      }

      setFormData(formFields);
    } catch (error) {
      setLoading(false);
      console.error("Error in changeFormField:", error);
      setError("An unexpected error occurred");
    }
  };

  const removeUploadedFile = (index) => {
    let formFields = { ...formData };
    formFields.uploadedFilesData.splice(index, 1);

    const uploadField = formFields.fields.find(
      (field) => field.type === "upload",
    );
    if (uploadField) {
      uploadField.value = null;
      uploadField.fileName = "";
      uploadField.fileLength = 0;
    }

    setFormData(formFields);
  };

  const handleRemoveFile = (index) => {
    removeUploadedFile(index);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const changeIsPublic = (index) => {
    let formFields = { ...formData };
    formFields.uploadedFilesData[index].isPublic =
      !formFields.uploadedFilesData[index].isPublic;
    setFormData(formFields);
  };

  const validateForm = async () => {
    try {
      setLoading(true);
      const validationResult = await bpmnFormValidator(formData.fields);
      if (validationResult !== "valid") {
        setError(validationResult);
        setLoading(false);
        return;
      }
      if (
        (props.actionStatus &&
          (props.actionStatus === "Confirm Installation" ||
            props.actionStatus === "CONFIRM_INSTALLATION")) ||
        props.data.name === "Confirm Installation" ||
        props.data.name === "CONFIRM_INSTALLATION"
      ) {
        formData.fields.map((obj) => {
          if (obj.id === "activationDate") {
            const pad = (num, size = 2) => String(num).padStart(size, "0");
            const date = new Date();
            const seconds = pad(date.getSeconds());
            const millis = pad(date.getMilliseconds(), 3);

            // Timezone offset in minutes, e.g. IST = -(-330) = 330
            const offsetMinutes = date.getTimezoneOffset();
            const sign = offsetMinutes > 0 ? "-" : "+";
            const absOffset = Math.abs(offsetMinutes);
            const offsetHours = pad(Math.floor(absOffset / 60));
            const offsetMins = pad(absOffset % 60);

            obj.value = `${obj.value}:${seconds}:${millis}${sign}${offsetHours}:${offsetMins}`;
            // obj.value = obj.value + "T00:00:00.000Z";
          }
        });
      }
      let payload = {
        taskId: formData.taskId,
        properties: formData.fields.map(({ id, value, fileData }) => ({
          id,
          value,
          ...(fileData && { fileData }),
        })),
        uploadedFilesData: formData.uploadedFilesData || [],
      };
      // return;
      if (payload.uploadedFilesData.length > 0) {
        await uploadFilesAndAttach(payload);
      }
      setLoading(false);
      console.log("check final payload", payload);
      props.close(payload);
    } catch (error) {
      setLoading(false);
      console.error("Error validating form:", error);
    }
  };

  // **Helper Function for File Uploads**
  const uploadFilesAndAttach = async (payload) => {
    for (let i = 0; i < payload.uploadedFilesData.length; i++) {
      const file = payload.uploadedFilesData[i];
      let formDataPayload = new FormData();
      formDataPayload.append("file", file.originalFile);

      try {
        const fileRes = await BusApiCall(
          "POST",
          `${constants.busV44UrlPublic}/flowable/bpmn/processInstance/${props.bpmnProcessInstanceId}/taskForms/${formData.taskId}/attachments`,
          formDataPayload,
        );

        payload.uploadedFilesData[i].fileData =
          fileRes.data.contentStoreId.split(".")[2];
      } catch (err) {
        let errorMessage =
          err.response?.data?.message || t("DEFAULT_ERROR_MESSAGE");
        setError(errorMessage);
      }
    }
  };

  return (
    <React.Fragment>
      <Dialog
        disableScrollLock={true}
        PaperComponent={DraggableDialogPaper}
        open={props.open}
        maxWidth={"md"}
        fullWidth={true}
      // PaperProps={{
      //     className: classess.resizablePaper
      // }}
      >
        <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
          <div style={{ display: "flex" }}>
            <span style={{ display: "inline-flex", width: "95%" }}>
              {formData.name}
            </span>
            <Tooltip title={t("CLOSE")}>
              <IconButton
                onTouchStart={() => {
                  props.close(false);
                }}
                onClick={() => {
                  props.close(false);
                }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={3}>
            {formData.fields &&
              formData.fields &&
              formData.fields.length > 0 &&
              formData.fields.map((input, index) => (
                <React.Fragment key={index}>
                  {input.type === "spacer" ? (
                    <Grid
                      item
                      style={{ marginTop: "15px" }}
                      size={{
                        xs: 12,
                      }}
                    ></Grid>
                  ) : input.type === "headline" ||
                    input.type === "headline-with-line" ? (
                    <>
                      <Grid
                        item
                        size={{
                          xs: 12,
                        }}
                      >
                        <h3
                          className="text-title"
                          style={{
                            fontWeight: "bold",
                            margin: 0,
                            textDecoration:
                              input.type === "headline-with-line"
                                ? "underline"
                                : "initial",
                          }}
                        >
                          {input.name}
                        </h3>
                      </Grid>
                    </>
                  ) : input.type === "horizontal-line" ? (
                    <Grid
                      item
                      size={{
                        xs: 12,
                      }}
                    >
                      <hr />
                    </Grid>
                  ) : input.type === "boolean" ? (
                    <Grid
                      item
                      key={index}
                      size={{
                        xs: 12,
                        md: 12,
                      }}
                    >
                      <GenericBPMNForm
                        input={input}
                        onChange={changeFormField}
                        minDate={props.minDate}
                        uploadedFilesData={
                          formData.uploadedFilesData
                            ? formData.uploadedFilesData
                            : []
                        }
                        changeIsPublic={changeIsPublic}
                        subItemAction={props.data.name}
                      />
                    </Grid>
                  ) : input.type === "hidden" ? (
                    <div style={{ display: "none" }} key={index}>
                      <GenericBPMNForm
                        input={input}
                        onChange={changeFormField}
                        minDate={props.minDate}
                        actionStatus={props.actionStatus}
                        uploadedFilesData={
                          formData.uploadedFilesData
                            ? formData.uploadedFilesData
                            : []
                        }
                        changeIsPublic={changeIsPublic}
                        subItemAction={props.data.name}
                      />
                    </div>
                  ) : input.type === "upload" ? (
                    <Grid
                      item
                      key={index}
                      size={{
                        xs: 12,
                        md: input.params && input.params.multiple ? 12 : 12,
                      }}
                    >
                      <GenericBPMNForm
                        input={input}
                        onChange={changeFormField}
                        minDate={props.minDate}
                        actionStatus={props.actionStatus}
                        uploadedFilesData={
                          formData.uploadedFilesData
                            ? formData.uploadedFilesData
                            : []
                        }
                        removeUploadedFile={handleRemoveFile}
                        changeIsPublic={changeIsPublic}
                        fileInputRef={fileInputRef}
                        subItemAction={props.data.name}
                      />
                    </Grid>
                  ) : (
                    <Grid
                      item
                      key={index}
                      size={{
                        xs: 12,
                        md: 6,
                      }}
                    >
                      <GenericBPMNForm
                        input={input}
                        onChange={changeFormField}
                        minDate={props.minDate}
                        actionStatus={props.actionStatus}
                        uploadedFilesData={
                          formData.uploadedFilesData
                            ? formData.uploadedFilesData
                            : []
                        }
                        changeIsPublic={changeIsPublic}
                        subItemAction={props.data.name}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Box sx={{ width: "100%" }}>
            <Grid container spacing={1} style={{ margin: 0 }}>
              <Grid
                style={{ color: "#f44336", fontWeight: "bold" }}
                size={{
                  xs: 8,
                }}
              >
                {error}
              </Grid>
              <Grid
                align="right"
                size={{
                  xs: 4,
                }}
              >
                {/* <Button onClick={() => props.close(false)} style={{ marginLeft: '8px' }}>{t('CANCEL')}</Button> */}
                <Button onClick={() => validateForm()}>{t("SUBMIT")}</Button>
              </Grid>
            </Grid>
          </Box>
        </DialogActions>
      </Dialog>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

const DraggableDialogPaper = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#draggableDialogPaper"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(OrderActionDialog));
